import React from 'react';
import {
  ResourceHeading2,
  ResourceParagraph,
} from 'components/theme/Typography/ResourceTypography';
import { useTranslation } from 'react-i18next';
import { Wrapper } from 'components/theme/Wrapper';
import {
  LayoutWrapper,
  Header,
  Main,
} from 'features/GuestReschedule/components/Layout';

interface NoBookingsAvailableProps {
  readonly title: string;
}

const NoBookingsAvailable = ({ title }: NoBookingsAvailableProps) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <LayoutWrapper>
        <Header>
          <ResourceHeading2 fontSize="28px" className="title">
            {title}
          </ResourceHeading2>
        </Header>
        <Main>
          <ResourceParagraph
            className="subtitle"
            fontSize="16px"
            opacity="0.7"
            fontWeight="400"
            lineHeight="20px"
          >
            {t('noBookingsAvailable')}
          </ResourceParagraph>
        </Main>
      </LayoutWrapper>
    </Wrapper>
  );
};

export default NoBookingsAvailable;
